import { render, staticRenderFns } from "./detailsTransporter.vue?vue&type=template&id=1ccdd40f"
import script from "./detailsTransporter.vue?vue&type=script&lang=js"
export * from "./detailsTransporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports